<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-md-12">
      <div class="card shadow">
        <div class="card-header bg-danger text-white">
          <h3 class="card-title text-center">Privacy Policy</h3>
        </div>
        <div class="card-body">
          <!-- Effective Date -->
          <p class="text-end text-muted"><em>Effective Date: July 16, 2025</em></p>

          <!-- Introduction Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Introduction</h4>
            <p>
              If you have any questions about this policy, contact us at:
              <strong>{{'support@smartdukaan.com'}}</strong>
            </p>
            <p>
              <strong>New Spice Solutions Pvt Ltd</strong> ("NSSPL", "We", "Us", "SmartDukaan") is committed to protecting your personal data and complying with applicable privacy laws in India and other regions where our product is distributed.
            </p>
            <p>
              This Privacy Policy explains what personal data we collect, how we use it, how it may be shared, and how you can manage it while using the SmartDukaan mobile or web application. By using our app, you agree to the terms of this Privacy Policy.
            </p>
          </section>

          <!-- Personal Information We Collect Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Personal Information We Collect</h4>
            <ul>
              <li>Name</li>
              <li>Phone Number</li>
              <li>Email Address</li>
              <li>Postal Address</li>
              <li>IP Address</li>
              <li>Android ID / Device Identifiers</li>
              <li>Location Data (foreground & background, with permission)</li>
              <li>Browser type and operating system</li>
              <li>App version and OS version</li>
              <li>App usage activity (pages visited, links clicked)</li>
            </ul>

            <h5 class="text-danger mt-4">Information you provide directly:</h5>
            <p>When using certain features such as check-in, visit management, or contact forms, we may collect your name, address, phone number, images, or location data.</p>

            <h5 class="text-danger mt-4">Automatically collected information:</h5>
            <p>Our app may automatically collect your device type, model, operating system, IP address, and interaction logs to improve performance and security.</p>

            <h5 class="text-danger mt-4">Information from third-party sources:</h5>
            <p>We may receive additional data from third-party login or analytics services, only with your consent.</p>
          </section>

          <!-- How We Use Your Information Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">How We Use Your Information</h4>
            <ul>
              <li>To register your device or account</li>
              <li>To enable attendance, visit tracking, and push notifications</li>
              <li>To send system or promotional updates (only with consent)</li>
              <li>To detect fraud or misuse and improve app performance</li>
              <li>To store check-in/check-out with time and location</li>
              <li>To analyze usage trends and service performance</li>
            </ul>
          </section>

          <!-- Permissions We Request -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Permissions We Request</h4>
            <p>We may request the following permissions to provide core functionality:</p>
            <ul>
              <li><strong>Location (foreground & background):</strong> To enable location tracking for attendance and visit management.</li>
              <li><strong>Camera:</strong> To capture verification images or documents during visits or user actions.</li>
              <li><strong>Media & Storage:</strong> To store captured images or related data locally.</li>
              <li><strong>Notifications:</strong> To alert users with reminders, check-in confirmations, or system alerts.</li>
              <li><strong>Device Info:</strong> Used for analytics, debugging, and unique identification.</li>
            </ul>
            <p>All permissions are requested with user consent during app use. You can manage permissions from your device settings.</p>
          </section>

          <!-- Disclosure of Personal Data Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Disclosure of Personal Data</h4>
            <ol type="a">
              <li class="mb-2">We may share your data with trusted service providers who help us operate the app, analyze data, or deliver notifications, under strict confidentiality.</li>
              <li class="mb-2">We may disclose information to comply with legal requirements or protect rights, safety, or security.</li>
              <li>We do not sell your personal information to third parties.</li>
            </ol>
          </section>

          <!-- Your Choices Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Your Choices</h4>
            <p>You can control and manage the following settings:</p>
            <ul>
              <li>Opt-out of marketing messages via email or in-app settings</li>
              <li>Control access to location, camera, or notifications via your phone settings</li>
              <li>Request data deletion or access by contacting {{'care@smartdukaan.com'}}</li>
            </ul>
          </section>

          <!-- Security Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Security</h4>
            <p>We apply appropriate technical and physical safeguards to protect your personal data. However, no app or platform can guarantee complete security over the internet.</p>
          </section>

          <!-- Links to Other Websites Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Links to Other Websites</h4>
            <p>Our application may link to third-party websites. We are not responsible for the content or privacy practices of these external sites. Please read their policies before interacting.</p>
          </section>

          <!-- Changes to the Privacy Policy Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Changes to the Privacy Policy</h4>
            <p>We may revise this policy from time to time. Material changes will be updated on this page along with an effective date. Continued use of the app implies acceptance.</p>
          </section>

          <!-- Contact Information Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Contact Information</h4>
            <ul>
              <li><strong>Email:</strong> {{'care@smartdukaan.com'}}</li>
              <li><strong>Company:</strong> New Spice Solutions Pvt Ltd</li>
              <li><strong>Address:</strong> Priska Tower, 2nd Floor, C-56/45, C Block, Industrial Area Phase 2, Sector 62, Noida - 201309 (UP)</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
